import { render, staticRenderFns } from "./shipping.vue?vue&type=template&id=0ea279d1&scoped=true&"
import script from "./shipping.vue?vue&type=script&lang=js&"
export * from "./shipping.vue?vue&type=script&lang=js&"
import style0 from "./shipping.vue?vue&type=style&index=0&id=0ea279d1&lang=scss&scoped=true&"
import style1 from "./shipping.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea279d1",
  null
  
)

export default component.exports